import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

function noop() {}

const MarketingTemplatesRefreshContext = createContext({
    refreshNonce: 0,
    requestMarketingTemplatesRefresh: noop,
});

/**
 * Wraps templates list + editor overlays so editors can notify consumers to reload template data after an update.
 */
export function MarketingTemplatesRefreshProvider({ children }) {
    const [refreshNonce, setRefreshNonce] = useState(0);
    const requestMarketingTemplatesRefresh = useCallback(() => {
        setRefreshNonce((n) => n + 1);
    }, []);
    const value = useMemo(
        () => ({
            refreshNonce,
            requestMarketingTemplatesRefresh,
        }),
        [refreshNonce, requestMarketingTemplatesRefresh],
    );
    return (
        <MarketingTemplatesRefreshContext.Provider value={value}>
            {children}
        </MarketingTemplatesRefreshContext.Provider>
    );
}

MarketingTemplatesRefreshProvider.propTypes = {
    children: PropTypes.node,
};

/** @returns {{ refreshNonce: number, requestMarketingTemplatesRefresh: () => void }} */
export function useMarketingTemplatesRefresh() {
    return useContext(MarketingTemplatesRefreshContext);
}
